// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "10599a0-dirty",
    "hash": "10599a0",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "10599a0-dirty",
    "semverString": null,
    "version": "1.1.288"
};
/* tslint:enable */
